/**
 * Mock bundle design for the "Double Wire Shelf" inseparable soft bundle (ISB) choice
 * (catalog choice 280103, see packoutMockData.js). "Double" means two of the SAME wire
 * shelf part used in Single Wire Shelf (same Sku/ChoiceId, 324536604/284360) — not a
 * different, wider shelf. Structurally this is bracket-shelf-bracket-shelf-bracket: 3
 * brackets, the middle one shared between both shelves. See
 * wallStorage-isb-singleWireShelf.mock.js for the full ISB design-shape explanation.
 *
 * Origin geometry generalizes that same file's confirmed-correct formula:
 *   bracket[i].Column = bracket[i-1].Column + SHELF_WIDTH
 *   shelf[i].Column   = bracket[i].Column + CELL_WIDTH
 * (bracket-left/shelf-left/bracket-right's per-pair relationship, repeated once more
 * from the middle bracket). Each bracket-to-bracket anchor distance is exactly one
 * shelf-width apart (confirmed against real bracket/shelf measurements — NOT
 * bracket-width + shelf-width, see wallStorage-isb-singleWireShelf.mock.js). shelf[i]
 * uses a FULL CELL_WIDTH nudge (not half) off its own preceding bracket — bracket[2]'s
 * real anchor-count offset lands close enough to a whole-column boundary
 * (SHELF_WIDTH / real column step ≈ 7.86, rounds to 8) that a half-width nudge for
 * shelf[2] rounds right back onto bracket[2]'s own anchor instead of the next one over;
 * a full-width nudge reliably clears that boundary for both shelves.
 */

const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000013';
const BRACKET_CHOICE_ID = 284358; // shared "Shelf Bracket" part choice, hidden from selector
const SHELF_CHOICE_ID = 284360; // same Wire Shelf part choice as Single Wire Shelf
const CELL_WIDTH = 330; // centiunits (3.3in), the bracket's own physical width
const SHELF_WIDTH = 2100; // centiunits (21in), the wire shelf's own physical width

const CELL_HEIGHT = 380; // centiunits (3.8in)

const BRACKET_1_COLUMN = 0;
const SHELF_1_COLUMN = BRACKET_1_COLUMN + CELL_WIDTH;
const BRACKET_2_COLUMN = BRACKET_1_COLUMN + SHELF_WIDTH;
const SHELF_2_COLUMN = BRACKET_2_COLUMN + CELL_WIDTH;
const BRACKET_3_COLUMN = BRACKET_2_COLUMN + SHELF_WIDTH;

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Double Wire Shelf (mock ISB)',
  Version: 1,
  ProductTypeId: null,
  Sku: null,
  Surface: null,
  Matrix: null,
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'isb-double-wire-shelf-bracket-1',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      Origin: {
        Row: 0, Column: BRACKET_1_COLUMN, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-double-wire-shelf-shelf-1',
      Type: 'Accessory',
      Sku: 324536604,
      Name: 'Double Wire Shelf (mock)',
      ChoiceId: SHELF_CHOICE_ID,
      Origin: {
        Row: 0, Column: SHELF_1_COLUMN, Height: CELL_HEIGHT / 2, Width: SHELF_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-double-wire-shelf-bracket-2',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      Origin: {
        Row: 0, Column: BRACKET_2_COLUMN, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 3,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-double-wire-shelf-shelf-2',
      Type: 'Accessory',
      Sku: 324536604,
      Name: 'Double Wire Shelf (mock)',
      ChoiceId: SHELF_CHOICE_ID,
      Origin: {
        Row: 0, Column: SHELF_2_COLUMN, Height: CELL_HEIGHT / 2, Width: SHELF_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 4,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-double-wire-shelf-bracket-3',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      Origin: {
        Row: 0, Column: BRACKET_3_COLUMN, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 5,
      TargetArea: null,
      ChoiceBundle: null,
    },
  ],
};

const wallStorageIsbDoubleWireShelfMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default wallStorageIsbDoubleWireShelfMock;
